import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { fetchProduct, updateProduct } from "../../actions/product-actions";
import { fetchIdentityProviders } from "../../actions/idp-actions";
import { Grid, Row, Col, Button } from "react-bootstrap";
import { isEmpty, set, get } from "lodash";
import { saveAs } from "file-saver";

import Breadcrumbs from "../../components/Breadcrumbs";
import SearchBar from "../../components/SearchBar";
import PropertyTitle from "../../components/PropertyTitle";
import PropertyInput from "../../components/PropertyInput";

import DurationInput from "../../components/DurationInput";
import NotFound from "../NotFound";
import moment from "moment";


class ProductDetail extends React.Component {
  componentDidMount() {
    this.props.fetchProduct(this.props.match.params.id);
    this.props.fetchIdentityProviders();
  }

  componentDidUpdate(oldProps) {
    if (this.props.match.params.id !== oldProps.match.params.id) {
      this.props.fetchProduct(this.props.match.params.id);
      this.props.fetchIdentityProviders();
    }
  }

  onSave(property, value) {
    let product = { ...this.props.product };
    // Extract string value from choice objects for renewable field
    if (property === 'renewable' && value && value.name) {
      value = value.name;
    }
    set(product, property, value);
    this.onSaveProduct(product);
  }

  onSaveRenewable(value) {
    // Auto-save for renewable field
    this.onSave('renewable', value);
  }

  onSaveProduct(product) {
    this.props.updateProduct(product).then(() => {
      this.props.fetchProduct(this.props.match.params.id);
    });
  }

  search(query) {
    this.props.history.push(`/producten?query=${query}`);
  }

  exportLicenses() {
    axios
      .get(
        `/api/products/${this.props.product.id}/licenses`,
        {
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        },
        {}
      )
      .then((result) => {
        let blob = new Blob([result.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "licenties.xlsx");
      });
  }

  render() {
    const { product, identityProviders } = this.props;
    if (product && product.id === -1) {
      return <NotFound />;
    }
    if (
      isEmpty(product) ||
      product.id !== parseInt(this.props.match.params.id, 10)
    ) {
      return null;
    }

    if (product.name.length > 35) {
      product.name_short =
        product.name.slice(0, 35 - product.name.length) + "\n.....";
    } else {
      product.name_short = product.name;
    }

    const licenseTypes = {
      LIC: "Standaard licentie",
      EBOOK: "E-boek",
      ABO: "Abonnement",
      LIC_MA: "Licentie met meervoudige activatie",
    };

    return (
      <Grid>
        <Breadcrumbs title={product.name} />
        <SearchBar
          placeholder="Zoek op EAN of naam"
          callback={(query) => this.search(query)}
        />

        <Row>
          <div className="content">
            <Row>
              <Col xs={12}>
                <span className="title">
                  <b>Product</b>
                </span>
              </Col>
            </Row>
            <Row>
              <Col md={6} sm={12}>
                <PropertyTitle icon="cube" text={product.name_short} />

                <PropertyInput
                  icon="database"
                  className="idp"
                  label="Identity provider"
                  type="choice"
                  property="identityProvider"
                  value={product.identityProvider}
                  choices={identityProviders}
                  onSave={(property, value) => this.onSave(property, value)}
                  entity="product"
                  entityId={this.props.match.params.id}
                />

                <PropertyInput
                  icon="file-text-o"
                  value={get(licenseTypes, product.productLicenseType)}
                  label="Type licentie"
                  disabled={true}
                />

                <DurationInput
                  product={product}
                  onSave={(product) => this.onSaveProduct(product)}
                  entity="product"
                  entityId={this.props.match.params.id}
                />

                <PropertyInput
                  icon="calendar-times-o"
                  className="deactivation-period"
                  label="Activatieperiode"
                  type="period"
                  property="activationPeriodNew"
                  value={product.activationPeriodNew}
                  onSave={(property, value) => this.onSave(property, value)}
                  entity="product"
                  entityId={this.props.match.params.id}
                />

                <PropertyInput
                  icon="calendar-times-o"
                  className="deactivation-period"
                  label="Deactivatieperiode"
                  type="period"
                  property="deactivationPeriod"
                  value={product.deactivationPeriod}
                  onSave={(property, value) => this.onSave(property, value)}
                  entity="product"
                  entityId={this.props.match.params.id}
                />

                <PropertyInput
                  icon="calendar-check-o"
                  className="grace-period"
                  label="Gedoogperiode"
                  type="period"
                  property="gracePeriod"
                  value={product.gracePeriod}
                  onSave={(property, value) => this.onSave(property, value)}
                  entity="product"
                  entityId={this.props.match.params.id}
                />
                <PropertyInput
                  icon="money"
                  className="credits"
                  label="Credits"
                  type="number"
                  property="credits"
                  value={product.credits}
                  onSave={(property, value) => this.onSave(property, value)}
                  entity="product"
                  entityId={this.props.match.params.id}
                />

                <PropertyInput
                  icon="external-link"
                  className="activationPageUrl"
                  label="Activatiepagina URL"
                  type="text"
                  property="activationPageUrl"
                  value={product.activationPageUrl}
                  onSave={(property, value) => this.onSave(property, value)}
                  entity="product"
                  entityId={this.props.match.params.id}
                />

                <PropertyInput
                  icon="external-link"
                  className="productPageUrl"
                  label="Productpagina URL"
                  type="text"
                  property="productPageUrl"
                  value={product.productPageUrl}
                  onSave={(property, value) => this.onSave(property, value)}
                  entity="product"
                  entityId={this.props.match.params.id}
                />

                <PropertyInput
                  icon="refresh"
                  className="renewable"
                  label="Renewable"
                  type="choice"
                  property="renewable"
                  value={product.renewable ? { name: product.renewable } : null}
                  choices={[
                    { name: "NO" },
                    { name: "FREE" },
                    { name: "PAID" }
                  ]}
                  onSave={(property, value) => this.onSaveRenewable(value)}
                  entity="product"
                  entityId={this.props.match.params.id}
                />

                <PropertyInput
                  icon="external-link"
                  className="prolongUrl"
                  label="Verlengingspagina URL"
                  type="text"
                  property="prolongUrl"
                  value={product.prolongUrl}
                  onSave={(property, value) => this.onSave(property, value)}
                  entity="product"
                  entityId={this.props.match.params.id}
                />

              </Col>
              <Col md={6} sm={12}>
                <PropertyTitle icon="barcode" text={product.ean} />
                <PropertyInput
                  icon="file-text-o"
                  type="content-references"
                  className="content-references"
                  label="Contentreferenties"
                  property="contentReferences"
                  value={product.contentReferences}
                  onSave={(property, value) => this.onSave(property, value)}
                />

                <PropertyInput
                  icon="calendar-check-o"
                  value={
                            Array.isArray(product.rollingEndDate)
                              ? moment([
                                  product.rollingEndDate[0],
                                  product.rollingEndDate[1] - 1,
                                  product.rollingEndDate[2]
                                ]).format("DD-MM")
                              : product.rollingEndDate
                              ? moment(product.rollingEndDate).format("DD-MM")
                              : '-'
                          }
                  label="Rollende einddatum"
                  disabled={true}
                />

                <PropertyInput
                  icon="calender-check-o"
                  value={product.extendable ? "Ja" : "Nee"}
                  label="Licentie verlengbaar"
                />
                <PropertyInput
                  icon="file-text-o"
                  value={product.productPermissions ? product.productPermissions : "-"}
                  label="Permissies"
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={2}>
                <Button bsStyle="success" onClick={() => this.exportLicenses()}>
                  Exporteer licenties
                </Button>
              </Col>
            </Row>
          </div>
        </Row>
      </Grid>
    );
  }
}

export default connect(
  (state) => {
    return {
      product: state.products.detail,
      identityProviders: state.identityProviders.list,
    };
  },
  {
    fetchProduct,
    updateProduct,
    fetchIdentityProviders,
  }
)(ProductDetail);
